import {Injector} from '@angular/core';
//@dynamic
export class StorageInjector {
  static injector?: Injector;
}
